import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@client-monorepo/common/network';
import { WithNavigationComponent } from '../with-navigation/with-navigation.component';
import { NoNavigationComponent } from '../no-navigation/no-navigation.component';
import { MiniAppHandlerComponent, miniAppMatcher } from '@client-monorepo/common/action-handler';
import { AbTestService } from '@client-monorepo/common/utilities';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: AbTestService.isShowHome() ? 'home' : 'hub',
  },
  {
    path: '',
    component: WithNavigationComponent,
    children: [
      {
        path: 'home',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/home').then((lib) => lib.homeRoutes),
        data: { animation: 'home' },
      },
      {
        path: 'transactions',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/transactions').then((c) => c.transactionRoutes),
        data: { animation: 'transactions' },
      },
      {
        path: 'hub',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/hub').then((lib) => lib.hubRoutes),
        data: { animation: 'hub' },
      },
      {
        path: 'stores',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/stores').then((lib) => lib.storesRoutes),
        data: { animation: 'stores' },
      },
      {
        path: 'profile',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/profile').then((lib) => lib.profileRoutes),
        data: { animation: 'profile' },
      },
    ],
  },
  {
    path: '',
    component: NoNavigationComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('@client-monorepo/applets/auth').then((lib) => lib.authRoutes),
        data: { animation: 'auth' },
      },
      {
        path: 'top-up',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/top-up').then((lib) => lib.topUpRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'internet',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/internet').then((lib) => lib.internetRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'payment',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/payment').then((lib) => lib.paymentRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'service/c2c',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/c2c').then((lib) => lib.c2cRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'bill',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/bill').then((lib) => lib.billRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'wallet-management',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/wallet-management').then((lib) => lib.walletManagementRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'cash-in',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/cash-in').then((lib) => lib.cashInRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'toll',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/toll').then((lib) => lib.tollRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'donation',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/charity').then((lib) => lib.charityRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'forgot-password',
        loadChildren: () => import('@client-monorepo/applets/forgot-password').then((lib) => lib.forgotPasswordRoutes),
        data: { animation: 'auth' },
      },
      {
        path: 'service/credit',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/credit').then((lib) => lib.creditRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'service/bnpl',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/credit').then((lib) => lib.bnplRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'pay-club',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/pay-club').then((lib) => lib.payClubRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'qr',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/scanner').then((lib) => lib.scannerRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'barcode',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/barcode').then((lib) => lib.barcodeRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'taxi-pay',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/taxi').then((lib) => lib.taxiRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'cash-out',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/cash-out').then((lib) => lib.cashOutRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'offline-payment',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/offline-payment').then((lib) => lib.offlinePaymentRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'fine',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/fine').then((lib) => lib.fineRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'subscription',
        canActivate: [AuthGuard],
        loadChildren: () => import('@client-monorepo/applets/subscription').then((lib) => lib.subscriptionRoutes),
        data: { animation: 'service' },
      },
      {
        path: 'mini-app/wealth',
        canActivate: [AuthGuard],
        loadComponent: () => import('@client-monorepo/applets/wealth').then((c) => c.WealthPageComponent),
        loadChildren: () => import('@client-monorepo/applets/wealth').then((lib) => lib.wealthRoutes),
        data: { animation: 'service' },
      },
    ],
  },
  {
    path: 'service/topup',
    redirectTo: 'top-up',
  },
  {
    path: 'service/bill',
    redirectTo: 'bill',
  },
  {
    path: 'service/internet',
    redirectTo: 'internet',
  },
  {
    path: 'service/toll',
    redirectTo: 'toll',
  },
  {
    path: 'service/driving-fine',
    redirectTo: 'fine',
  },
  {
    path: 'service/donation',
    redirectTo: 'donation',
  },
  {
    path: 'service/cashin',
    redirectTo: 'cash-in',
  },
  {
    path: 'service/qr',
    redirectTo: 'qr',
  },
  {
    matcher: miniAppMatcher,
    component: MiniAppHandlerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
